/**
 * Simulate a click event.
 * @public
 * @param {Element} elem  the element to simulate a click on
 */
var simulateClick = function (elem) {
  // Create our event (with options)
  var evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  // If cancelled, don't dispatch our event
  var canceled = !elem.dispatchEvent(evt);
};

//fonction du click gauche
var decodeLink = function(event) {
  var attribute = this.getAttribute("data-obfusq");
  if(event.ctrlKey) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    document.location.href= decodeURIComponent(window.atob(attribute));
  }
};
//fonction du click droit
var decodeRightLink = function(event) {
  var attribute = this.getAttribute("data-obfusq");
  if(event.ctrlKey) {
    var newWindow = window.open(decodeURIComponent(window.atob(attribute)), '_blank');
    newWindow.focus();
  } else {
    window.open(decodeURIComponent(window.atob(attribute)),'_blank');
  }
}

document.addEventListener("DOMContentLoaded", function() {

  var classname = document.getElementsByClassName("mk-obfusq");
  for (var i = 0; i < classname.length; i++) {
    //click gauche
    classname[i].addEventListener('click', decodeLink, false);
    //click droit
    classname[i].addEventListener('contextmenu', decodeRightLink, false);
  }

  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    window.scrollTo({
      top: document.getElementById(hash).offsetTop,
      behavior: "smooth"
    });
  }

  var offset = 300,
    offset_opacity = 1200,
    scroll_top_duration = 700,
    back_to_top = document.querySelector('.cd-top');

  window.addEventListener("scroll", function() {
    if (window.scrollY > offset) {
      back_to_top.classList.add('cd-is-visible');
    } else {
      back_to_top.classList.remove('cd-is-visible', 'cd-fade-out');
    }
    if (window.scrollY > offset_opacity) {
      back_to_top.classList.add('cd-fade-out');
    }
  });

  back_to_top.addEventListener('click', function(event) {
    event.preventDefault();
    var scrollAnimation = setInterval(function() {
      if (window.scrollY != 0) {
        window.scrollBy(0, -30);
      } else {
        clearInterval(scrollAnimation);
      }
    }, 16);
  });
});